import { ROUTES } from 'constants/routesConstants'
import { PmsPaymentProviderEnum } from 'features/purchase/pms/pmsTypes'
import { User } from 'types/auth'
import { FlowTypeEnum, Subscription, UserStatusEnum } from 'types/subscription'

type CheckoutRouteType = 'index' | 'plans' | 'upgrade'

export const shouldDisplayUnlockFlowUI = (
	user: User,
	routeType?: CheckoutRouteType,
) => {
	if (
		user.flow === FlowTypeEnum.UNLOCK ||
		user.status === UserStatusEnum.PREMIUM_UNPAID ||
		user.status === UserStatusEnum.PREMIUM_CANCELLED ||
		user.status === UserStatusEnum.PREMIUM_IN_DEBT ||
		routeType === 'plans'
	) {
		return true
	}

	return false
}

export const isPaypalSubscription = (
	subscription?: Pick<Subscription, 'provider'> | null,
) => subscription?.provider === PmsPaymentProviderEnum.PAYPAL_SUBSCRIPTION

export const getFixPaymentRoute = (
	subscription?: Pick<Subscription, 'provider'> | null,
) => (isPaypalSubscription(subscription) ? ROUTES.plans : ROUTES.checkout.plans)
